import { render, staticRenderFns } from "./Exporter.vue?vue&type=template&id=04b8709a"
import script from "./Exporter.vue?vue&type=script&lang=ts"
export * from "./Exporter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports